// @ts-check
import { css, jsx } from '@emotion/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { space } from '@/styles';
import ProfileTile from './ProfileTile';

const style = {
  profilesList: css`
    display: flex;
    flex-wrap: wrap;
    margin: -10px;
  `,
};

export default function ChartProfiles(props) {
  const { profiles = [], route, enableBio, seniorStaff } = props;
  const isLoggedIn = useSelector(/** @param {import("@/src/types").RootState} s */(s) => s.auth.isLoggedIn);

  return (
    <div css={[space.m.b16, style.profilesList]}>
      {profiles.map(p => (
        <ProfileTile
          key={p.PersonId}
          profile={p}
          route={route}
          isLoggedIn={isLoggedIn}
          enableBio={enableBio}
          seniorStaff={seniorStaff}
        />
      ))}
    </div>
  );
};
